import { render, staticRenderFns } from "./ReplyMessage.vue?vue&type=template&id=f4f6465e&scoped=true"
import script from "./ReplyMessage.vue?vue&type=script&lang=js"
export * from "./ReplyMessage.vue?vue&type=script&lang=js"
import style0 from "./ReplyMessage.vue?vue&type=style&index=0&id=f4f6465e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f6465e",
  null
  
)

export default component.exports